(function ({ jQuery: $, Slider }) {
  /*! ===== 여기에 스크립트를 작성해 주세요. ===== */

  const $container = $('#history');

  const activateArrows = slider => {
    $container.on('click', '.timeline_arrow', function () {
      const isNext = $(this).hasClass('timeline_arrow_next');

      if (isNext) {
        slider.next();
      } else {
        slider.prev();
      }
    });
  };

  const updateClasses = slider => {
    const { progressSlides, relativeSlide } = slider.details();

    const progress = progressSlides % 1;
    const hasPrevious = relativeSlide > 1;
    const hasNext = progress < 0.5;

    $container
      .find('.timeline_arrow_previous')
      .prop('disabled', !hasPrevious)
      .end()
      .find('.timeline_arrow_next')
      .prop('disabled', !hasNext);
  };

  new Slider('#historyTimeline', {
    mode: 'free',
    slidesPerView: 3,
    created: slider => {
      updateClasses(slider);
      activateArrows(slider);
    },
    slideChanged: slider => {
      updateClasses(slider);
    },
  });
})(
  (function (jQuery, Slider) {
    requireModule('jQuery', typeof jQuery === 'function');
    requireModule('KeenSlider', typeof Slider === 'function');

    function requireModule(name, predicate) {
      if (!predicate) {
        throw new Error(
          `Unable to find ${name} module. Please make sure it is loaded before this script.`
        );
      }
    }

    return { jQuery, Slider };
  })(window.jQuery, window.KeenSlider)
);
